import {
    SET_PAGE_TITLE, QUERY_STRING_CHANGED, SET_QUERY_STRING, SET_QUERY_STRING_SINGLE_PARAM, ADD_TO_QUERY_STRING
} from '../types';
import { GetQueryString, SetQueryString, SetParamQueryString, AssignObjectToQueryString } from '../../helpers';

const INITIAL_STATE_TITLE = "MISSING TITLE"

export var titleReducer = (state = INITIAL_STATE_TITLE, action) => {
    switch (action.type) {
        case SET_PAGE_TITLE:
            return action.payload
        default:
            return state;
    }
}

const INITIAL_STATE_QUERY = {};

export var queryStringReducer = (state = INITIAL_STATE_QUERY, action) => {
    switch (action.type) {
        case QUERY_STRING_CHANGED:
            return GetQueryString();
        case ADD_TO_QUERY_STRING:
            AssignObjectToQueryString(action.payload);
            return { ...state, ...action.payload };
        case SET_QUERY_STRING:
            SetQueryString(action.payload);
            return { ...action.payload };
        case SET_QUERY_STRING_SINGLE_PARAM:
            SetParamQueryString(action.name, action.payload);
            return { ...state, [action.name]: action.payload };
        default:
            return state;
    }
}
